import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getPriceStr } from '../../../../helpers/utils';
import Button from '../../../ui/Button';
import ReturnNotificationCheckboxes from './ReturnNotification/ReturnNotificationCheckboxes';
import RefundRules from './RefundRules/RefundRules';
import ReturnReason from './ReturnReason/ReturnReason';
import FieldWrapper from '../../../components/form-elements/FieldWrapper';
import ReturnSegmentPolicy from './ReturnSegmentPolicy/ReturnSegmentPolicy';
import ReturnSegment from './ReturnSegment/ReturnSegment';
import { MAX_COMMENT_LENGTH } from '../../../../constants/settings';
const fileExtensions = 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, image/gif, image/jpeg, image/png, .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx';
const OrderReturn = ({
  selectedTickets,
  segments = [],
  insurances,
  onSubmit,
  voluntaryReason,
  inVoluntaryReason,
  onReasonChange,
  onTicketChange,
  onCommentChange,
  commentValue,
  commentLength,
  onFocus,
  onBlur,
  isVoluntary,
  isInVoluntary,
  isCommentValid,
  isButtonDisabled,
  isLoading,
  isPaymentOffline,
  onFileUploaded,
  isFileUploaded,
  refundRules,
  refundNotifications,
  clickOnNotificationCheckbox,
  openModal,
  errorMessage
}) => {
  const hasInsurances = !!insurances.length;
  let formattedInsurancePrice = null;
  if (hasInsurances) {
    const {
      price
    } = insurances[0];
    formattedInsurancePrice = I18n.l('number.currency', getPriceStr(price));
  }
  const downloadButtonName = isFileUploaded ? I18n.t('components.OrderReturn.download_file_success') : I18n.t('components.OrderReturn.download_file');
  return /*#__PURE__*/React.createElement("div", {
    className: "order-return"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return__title"
  }, I18n.t('components.OrderReturn.step.one.title')), /*#__PURE__*/React.createElement("p", {
    className: "order-return__sub-title"
  }, I18n.t('components.OrderReturn.step.one.subtitle')), segments.map(({
    segmentId,
    carrierName,
    segmentCityFrom,
    segmentCityTo,
    tickets
  }) => /*#__PURE__*/React.createElement(ReturnSegment, {
    key: segmentId,
    carrierName: carrierName,
    segmentCityFrom: segmentCityFrom,
    segmentCityTo: segmentCityTo,
    tickets: tickets,
    onTicketChange: onTicketChange,
    selectedTickets: selectedTickets
  })), /*#__PURE__*/React.createElement("div", {
    className: "order-return__title"
  }, I18n.t('components.OrderReturn.step.two.title')), /*#__PURE__*/React.createElement("p", {
    className: "order-return__sub-title"
  }, I18n.t('components.OrderReturn.step.two.subtitle')), /*#__PURE__*/React.createElement("div", {
    className: "order-return__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return__attention"
  }, /*#__PURE__*/React.createElement("span", {
    className: "order-return__attention__icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "order-return__attention-text"
  }, I18n.t('components.OrderReturn.attention')))), /*#__PURE__*/React.createElement("div", {
    className: "order-return__form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement(ReturnReason, {
    title: I18n.t('components.OrderReturn.voluntary_title'),
    description: !voluntaryReason ? I18n.t('components.OrderReturn.voluntary_description_disable') : I18n.t('components.OrderReturn.voluntary_description'),
    onClick: () => onReasonChange(voluntaryReason),
    isChecked: isVoluntary,
    isDisabled: !voluntaryReason
  }), inVoluntaryReason && /*#__PURE__*/React.createElement(ReturnReason, {
    title: I18n.t('components.OrderReturn.necessary_title'),
    description: I18n.t('components.OrderReturn.necessary_subtitle'),
    onClick: () => onReasonChange(inVoluntaryReason),
    isChecked: isInVoluntary
  }))), isInVoluntary && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FieldWrapper, {
    label: I18n.t('components.OrderReturn.comment_label'),
    isValid: isCommentValid,
    errors: [I18n.t('components.OrderReturn.comment_error')]
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('order-return__comment-counter', {
      warning: commentLength >= MAX_COMMENT_LENGTH
    })
  }, `${commentLength}/${MAX_COMMENT_LENGTH}`), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    onChange: onCommentChange,
    onFocus: onFocus,
    onBlur: onBlur,
    value: commentValue,
    name: "",
    id: "",
    cols: "6",
    rows: "4",
    placeholder: I18n.t('components.OrderReturn.comment_placeholder'),
    maxLength: MAX_COMMENT_LENGTH
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "order-return__form-title"
  }, I18n.t('components.OrderReturn.refund_tickets_policy_title')), segments.map(segment => /*#__PURE__*/React.createElement(ReturnSegmentPolicy, {
    key: segment.segmentId,
    ...segment
  }))), hasInsurances && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "order-return__form-title"
  }, I18n.t('components.OrderReturn.refund_insurances_policy_title')), /*#__PURE__*/React.createElement("div", null, I18n.t('components.OrderReturn.refund_insurances_policy_description', {
    price: formattedInsurancePrice
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "order-return__title"
  }, I18n.t('components.OrderReturn.step.three.title')), /*#__PURE__*/React.createElement("p", {
    className: "order-return__sub-title"
  }, I18n.t('components.OrderReturn.step.three.subtitle')), /*#__PURE__*/React.createElement("div", {
    className: "order-return__compliance"
  }, /*#__PURE__*/React.createElement(RefundRules, {
    rules: refundRules
  }), /*#__PURE__*/React.createElement("p", {
    className: "order-return__compliance-title"
  }, I18n.t('components.OrderReturn.compliance.text')), isPaymentOffline ? /*#__PURE__*/React.createElement("div", {
    className: "order-return__compliance-offline"
  }, /*#__PURE__*/React.createElement("p", {
    className: "order-return__compliance-sub-title"
  }, I18n.t('components.OrderReturn.compliance.subtext_offline.paragraph_one')), /*#__PURE__*/React.createElement("p", {
    className: "order-return__compliance-sub-title"
  }, I18n.t('components.OrderReturn.compliance.subtext_offline.paragraph_two'))) : /*#__PURE__*/React.createElement("p", {
    className: "order-return__compliance-sub-title"
  }, I18n.t('components.OrderReturn.compliance.subtext')), /*#__PURE__*/React.createElement(ReturnNotificationCheckboxes, {
    refundNotifications: refundNotifications,
    clickOnNotificationCheckbox: clickOnNotificationCheckbox,
    openModal: openModal
  }), /*#__PURE__*/React.createElement("div", {
    className: "order-return__compliance-submit"
  }, isPaymentOffline && /*#__PURE__*/React.createElement("div", {
    className: "order-return__compliance-upload"
  }, /*#__PURE__*/React.createElement("input", {
    className: "order-return__compliance-upload-btn",
    onChange: onFileUploaded,
    type: "file",
    id: "upload-btn",
    accept: fileExtensions
  }), /*#__PURE__*/React.createElement("label", {
    className: "btn btn-primary btn-link",
    htmlFor: "upload-btn"
  }, downloadButtonName), /*#__PURE__*/React.createElement("span", {
    className: "arrow"
  }, "↑")), /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    isLoading: isLoading,
    isDisabled: isButtonDisabled,
    size: "md",
    variant: "primary",
    title: I18n.t('components.OrderReturn.button')
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "order-return__error"
  }, errorMessage)));
};
OrderReturn.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    segmentId: PropTypes.string
  })),
  insurances: PropTypes.array.isRequired,
  onSubmit: PropTypes.func,
  selectedTickets: PropTypes.arrayOf(PropTypes.string),
  commentValue: PropTypes.string,
  commentLength: PropTypes.number,
  onReasonChange: PropTypes.func,
  onTicketChange: PropTypes.func,
  onCommentChange: PropTypes.func,
  voluntaryReason: PropTypes.string,
  inVoluntaryReason: PropTypes.string,
  isVoluntary: PropTypes.bool,
  isInVoluntary: PropTypes.bool,
  errorMessage: PropTypes.string,
  isCommentValid: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  isButtonDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPaymentOffline: PropTypes.bool.isRequired,
  onFileUploaded: PropTypes.func.isRequired,
  isFileUploaded: PropTypes.bool.isRequired,
  clickOnNotificationCheckbox: PropTypes.func,
  refundRules: PropTypes.arrayOf(PropTypes.string),
  refundNotifications: PropTypes.arrayOf(PropTypes.shape({
    position: PropTypes.number,
    type: PropTypes.string,
    isChecked: PropTypes.bool,
    modalUrl: PropTypes.string
  })),
  openModal: PropTypes.func
};
export default OrderReturn;